import { datadogLogs } from '@datadog/browser-logs';
import config from 'config';

let isDatadogLoaded = false;

export const initDatadog = (userName: string) => {
    if (config.datadog.enabled && __RELEASE__ && !isDatadogLoaded) {
        datadogLogs.init({
            clientToken: config.datadog.clientToken,
            env: config.datadog.environment,
            service: 'admin-front',
            site: 'datadoghq.eu',
            sessionPersistence: 'memory',
            forwardErrorsToLogs: true,
            forwardConsoleLogs: ['error'],
            version: __RELEASE__,
            beforeSend: (_event, context) => {
                if (context && 'isAborted' in context && context?.isAborted) {
                    return false;
                }
                return true;
            },
        });

        datadogLogs.setUser({
            id: userName,
        });
    }
    isDatadogLoaded = true;
};
